var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenueBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Venue-Black"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Venue-Black",
    clipPath: "url(#clip-Venue-Black)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Venue-Black-2",
    "data-name": "Venue-Black",
    d: "M4.782,10.192C4.782,4.627,9.556.125,15.459.125s10.677,4.5,10.677,10.067c0,6-6.742,14.266-9.5,17.416a1.574,1.574,0,0,1-2.334,0C11.523,24.458,4.782,16.189,4.782,10.192Zm6.864,0a3.71,3.71,0,0,0,3.813,3.6,3.71,3.71,0,0,0,3.813-3.6,3.71,3.71,0,0,0-3.813-3.6A3.71,3.71,0,0,0,11.645,10.192Z",
    transform: "translate(2.541 3.875)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenueBlack);
export default __webpack_public_path__ + "static/media/Venue-Black.c2e437a79d045ace07ff8ab3c3b8a03a.svg";
export { ForwardRef as ReactComponent };